import { gql } from '@apollo/client'

export interface TcVarsDataType {
  // TagCommander variables of the Contact, as a JSON string
  tcVars: string
}

export const GET_TAG_COMMANDER_VARS = gql`
  query TcVars {
    tcVars
  }
`
